import { render } from "./ReservationPage.vue?vue&type=template&id=a27cbd5c&ts=true"
import script from "./ReservationPage.vue?vue&type=script&lang=ts"
export * from "./ReservationPage.vue?vue&type=script&lang=ts"

import "./ReservationPage.vue?vue&type=style&index=0&id=a27cbd5c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__